import { useMemo } from "react";

import { generatePath, Redirect, useParams } from "react-router-dom";

import { useOrganization } from "@/hooks/useOrganization";
import { ROUTES } from "@/routes_new";
import { OrganizationStatus } from "@/types/Organization";
import { useGroupedSearches } from "@/hooks/useGroupedSearches";
import { useSearches } from "@/hooks/useSearches";

export const MentionsRedirectView = () => {
  const { orgUuid } = useParams<{ orgUuid: string }>();
  const { data: orgData } = useOrganization();
  const orgStatus = orgData?.ok ? orgData.data.status : null;

  const { data: searchesData } = useSearches(orgUuid);

  const searches = searchesData?.ok ? searchesData.data : undefined;
  const groupedSearches = useGroupedSearches(searchesData);

  const redirectTarget = useMemo(() => {
    if (!orgUuid || !searches) return undefined;

    const firstActive = groupedSearches.activeSearches[0];
    if (firstActive) {
      return generatePath(ROUTES.MENTION_DETAIL_ORGID, {
        orgUuid,
        uuid: firstActive.uuid,
      });
    }

    // orgStatus only needed from here — wait for it before choosing fallback
    if (!orgStatus) return undefined;

    // For expired automatic trial orgs, fall back to inactive searches
    if (orgStatus === OrganizationStatus.AutomaticTrialExpired) {
      const firstInactive = groupedSearches.inactiveSearches[0];
      if (firstInactive) {
        return generatePath(ROUTES.MENTION_DETAIL_ORGID, {
          orgUuid,
          uuid: firstInactive.uuid,
        });
      }
    }

    return generatePath(ROUTES.SEARCH_ORGID, { orgUuid });
  }, [orgUuid, orgStatus, searches, groupedSearches]);

  if (redirectTarget && orgUuid) {
    return <Redirect to={redirectTarget} />;
  }

  return null;
};
